import React, {useState} from 'react';
import './ProfileVerification.scss';
import {withRouter} from "react-router-dom";
import {assetUrl} from "../../serviceApi";

const arrowRight = assetUrl+'images/white-arrow-right.png';
const backArrow = assetUrl+"images/icon_black-arrow-left.svg";
const wallet = assetUrl+"images/icon_wallet.svg";
const bell = assetUrl+"images/icon_blackBell.svg";
const upload = assetUrl+'images/icon_upload.svg';
const note = assetUrl+'images/icon_info.svg';
const points = assetUrl+'images/icon_points.svg'
const arrowRightPurple = assetUrl+'images/arrow-right-s-line.png'

const ProfileVerification = (props) => {
    const styleProfileVerification = "profile-verification-"
    const [activeTab, setActiveTab] = useState("personal");
    return (
        <div className={styleProfileVerification + "main"}>
            {/* top nav */}
            <div className={' d-flex justify-content-between align-items-center  py-2 px-1'}>
                <div className={'d-flex'}>
                    <img alt={'alt'} src={backArrow} onClick={() => props.history.push("/wallet")}/>
                    <p className={styleProfileVerification + "nav-text my-1"}>Profile Verification</p>
                </div>
                <div className={'d-flex mx-2'}>
                    {window.location.pathname === "/profile-verification" ? null :
                        <img src={wallet} alt={'wallet'} className={" mx-3"}/>}
                    <img src={bell} alt={'notify'} className={" mx-1"}
                         onClick={() => props.history.push("/notification")}/>
                </div>
            </div>
            {/* tabs */}
            <div style={activeTab === "personal" ? {overflow: "scroll"} : {overflow: "scroll", marginLeft: "-12vh"}}>
                <div className={styleProfileVerification + 'tab-main d-flex'}>
                    <div onClick={() => setActiveTab("personal")}
                         className={activeTab === "personal" ? styleProfileVerification + "tabWrap-active mx-2" : styleProfileVerification + "tabWrap mx-2"}>
                        <p className={styleProfileVerification + "tab-text my-1 mr-1 "}>Personal Details</p>
                        <hr className={styleProfileVerification + "tab-underline mt-0 mb-1"}/>
                    </div>
                    <div onClick={() => setActiveTab("address")}
                         className={activeTab === "address" ? styleProfileVerification + "tabWrap-active mx-2" : styleProfileVerification + "tabWrap mx-2"}>
                        <p className={styleProfileVerification + "tab-text my-1 mr-1"}>Address Proof</p>
                        <hr className={styleProfileVerification + "tab-underline mt-0 mb-1"}/>
                    </div>
                    <div onClick={() => setActiveTab("bank")}
                         className={activeTab === "bank" ? styleProfileVerification + "tabWrap-active mx-2" : styleProfileVerification + "tabWrap mx-2"}>
                        <p className={styleProfileVerification + "tab-text my-1 mr-1"}>Bank Details</p>
                        <hr className={styleProfileVerification + "tab-underline mt-0 mb-1"}/>
                    </div>
                </div>
            </div>
            {/* tab contents */}

            {
                activeTab === "personal" ?
                    // personal details
                    <div className={"my-3 container"}>
                        <div className={"my-3"}>
                            <p className={styleProfileVerification + "label my-1"}>Full Name</p>
                            <input type={'text'} className={styleProfileVerification + "inputText p-2"}/>
                        </div>
                        <div className={"my-3"}>
                            <p className={styleProfileVerification + "label my-1"}>Email Address</p>
                            <input type={'email'} className={styleProfileVerification + "inputText p-2"}/>
                        </div>
                        <div className={"my-3"}>
                            <p className={styleProfileVerification + "label my-1"}>Date of Birth</p>
                            <input className={styleProfileVerification + "inputText p-2"}
                                   placeholder={"Select Birthday"}/>
                        </div>
                        <div className={"my-3"}>
                            <p className={styleProfileVerification + "label my-1"}>Select State</p>
                            <select className={styleProfileVerification + "inputText p-2"}>
                                <option>Select Your State</option>
                                <option> Tamil Nadu</option>
                                <option> Kerala</option>
                                <option> Andhra Pradesh</option>
                                <option> Karnataka</option>
                            </select>
                        </div>


                    </div> :
                    activeTab === "address" ?
                        // Address Proof
                        <div className={"my-3 container"}>
                            <div className={"my-3"}>
                                <p className={styleProfileVerification + "label my-1"}>Select Method</p>
                                <select className={styleProfileVerification + "inputText p-2"}>
                                    <option>Select one Method</option>
                                    <option> method 1</option>
                                    <option> method 2</option>
                                    <option> method 3</option>
                                    <option> method 4</option>
                                </select>
                            </div>
                            <div className={"my-3"}>
                                <p className={styleProfileVerification + "label my-1"}>Aadhar Card Number</p>
                                <input type={'number'} className={styleProfileVerification + "inputText p-2"}/>
                            </div>
                            <div className={"my-3"}>
                                <p className={styleProfileVerification + "label my-1"}>Name (As on Card)</p>
                                <input type={'text'} className={styleProfileVerification + "inputText p-2"}/>
                            </div>
                            <div className={"my-2"}>
                                <p className={styleProfileVerification + "label my-1"}>Aadhar Card</p>
                                <div
                                    className={styleProfileVerification + "attachment py-2 px-2 d-flex align-items-center justify-content-center"}>
                                    <img src={upload} alt={"alt"}
                                         className={styleProfileVerification + "adhaarAttchment-icon"}/>
                                    <p className={styleProfileVerification + "attachment-text mx-2 my-1"}>Drop
                                        files here or
                                        browse files</p>
                                </div>
                            </div>
                            <div className={'d-flex align-items-center'}>
                                <img src={note} alt={"alt"} style={{width: "2vh", objectFit: "contain"}}/>
                                <p className={styleProfileVerification + "attachment-info mx-2 my-1"}>JPEG, PNG
                                    and PDF file supported.</p>
                            </div>
                            <p className={styleProfileVerification + "note-main my-1"}>Why is this required?</p>
                            <p className={styleProfileVerification + "note-sub my-1"}>Lorem ipsum dolor sit amet,
                                consectetur
                                adipiscing elit. In volutpat eget eget vitae, libero, tincidunt auctor mi augue.</p>

                        </div> :
                        activeTab === "bank" ?
                            <div className={"my-3 container"}>
                                <div className={"my-3"}>
                                    <p className={styleProfileVerification + "label my-1"}>Account Number</p>
                                    <input type={'number'} className={styleProfileVerification + "inputText p-2"}/>
                                </div>
                                <div className={"my-3"}>
                                    <p className={styleProfileVerification + "label my-1"}>IFSC Code</p>
                                    <input type={'text'} className={styleProfileVerification + "inputText p-2"}/>
                                </div>
                                <div className={"my-2"}>
                                    <p className={styleProfileVerification + "label my-1"}>Bank Statement Or Passbook
                                        front copy</p>
                                    <div
                                        className={styleProfileVerification + "attachment py-2 px-2 d-flex align-items-center justify-content-center"}>
                                        <img src={upload} alt={"alt"}
                                             className={styleProfileVerification + "adhaarAttchment-icon"}/>
                                        <p className={styleProfileVerification + "attachment-text mx-2 my-1"}>Drop
                                            files here or
                                            browse files</p>
                                    </div>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    <img src={note} alt={"alt"} style={{width: "2vh", objectFit: "contain"}}/>
                                    <p className={styleProfileVerification + "attachment-info mx-2 my-1"}>JPEG, PNG
                                        and PDF file supported.</p>
                                </div>
                                <div className={styleProfileVerification + "bank-notes"}>
                                    <div className={'d-flex align-items-center'}>
                                        <img src={points} alt={'alt'} style={{width: ".8vh", objectFit: "contain"}}/>
                                        <p className={styleProfileVerification + "bank-notes-text mx-2 my-1"}>Lorem
                                            ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                    </div>
                                    <div className={'d-flex align-items-center'}>
                                        <img src={points} alt={'alt'} style={{width: ".8vh", objectFit: "contain"}}/>
                                        <p className={styleProfileVerification + "bank-notes-text mx-2 my-1"}>Lorem
                                            ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                    </div>
                                    <div className={'d-flex align-items-center'}>
                                        <img src={points} alt={'alt'} style={{width: ".8vh", objectFit: "contain"}}/>
                                        <p className={styleProfileVerification + "bank-notes-text mx-2 my-1"}>Lorem
                                            ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                    </div>
                                </div>
                            </div>
                            // Bank Details
                            : null
            }


            {/* bottom buttons   */}
            <div
                className={styleProfileVerification + "bottomWrap d-flex justify-content-center align-items-end mx-auto "}>
                {
                    activeTab === "personal" ?
                        <button onClick={() => setActiveTab("address")}
                                className={styleProfileVerification + "buttonLarge d-flex  justify-content-center align-items-center px-2 py-2 my-1"}>
                            <p className={"my-1 mx-2"}>Next</p>
                            <img src={arrowRight} alt={"alt"} className={styleProfileVerification + "button-icon"}/>
                        </button> :
                        activeTab === "address" ?
                            <div className={"d-flex justify-content-center"}>
                                <button onClick={() => setActiveTab("personal")}
                                        className={styleProfileVerification + "whiteBgBtn d-flex align-items-center justify-content-center px-2 py-2 mx-2"}>
                                    <p className={'ml-2 my-1'}>Previous</p>
                                    <img src={arrowRightPurple} alt={"alt"}
                                         style={{width: "24px", objectFit: "contain"}}/>
                                </button>
                                <button onClick={() => setActiveTab("bank")}
                                        className={styleProfileVerification + "purpleBgBtn d-flex align-items-center justify-content-center px-2 py-2 mx-2"}>
                                    <p className={'mr-2 my-1'}>Next</p>
                                    <img src={arrowRight} alt={"alt"} style={{width: "1vh", objectFit: "contain"}}/>
                                </button>
                            </div> :
                            activeTab === "bank" ?
                                <div className={"d-flex justify-content-center"}>
                                    <button onClick={() => setActiveTab("address")}
                                            className={styleProfileVerification + "whiteBgBtn d-flex align-items-center justify-content-center px-2 py-2 mx-2"}>
                                        <p className={'ml-2 my-1'}>Previous</p>
                                        <img src={arrowRightPurple} alt={"alt"}
                                             style={{width: "24px", objectFit: "contain"}}/>
                                    </button>
                                    <button
                                        className={styleProfileVerification + "purpleBgBtn d-flex align-items-center justify-content-center px-2 py-2 mx-2"}>
                                        <p className={'mr-2 my-1'}>Verify</p>
                                        <img src={arrowRight} alt={"alt"} style={{width: "1vh", objectFit: "contain"}}/>
                                    </button>
                                </div> :
                                null
                }
            </div>

        </div>
    )
}

export default withRouter(ProfileVerification)
